<script lang="ts">
	interface Props {
		strokeColor: string
	}

	let { strokeColor }: Props = $props()
</script>

<svg
	width="100%"
	height="100%"
	viewBox="0 0 3000 500"
	version="1.1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	xml:space="preserve"
	style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"
	><g id="LUXPLAY"
		><path
			id="L"
			d="M1768.6,61.762l38.556,-0l0.348,337.354l336.644,0.156l0.152,38.927l-375.352,0.039l-0.348,-376.476Z"
			style="stroke:{strokeColor};fill:{strokeColor};stroke-width:1px;"
		/><path
			d="M2201.28,438.238l168.709,-376.476l37.934,-0l168.709,376.476l-37.934,0l-149.742,-335.554l-67.84,154.57l108.558,-0l13.905,34.589l-138.038,-0l-66.327,146.395l-37.934,0Z"
			style="stroke:{strokeColor};fill:{strokeColor};stroke-width:0.54px;stroke-linecap:butt;"
		/><g id="P"
			><path
				id="I--1-"
				d="M1393.88,438.154l0.002,-216.106l-39.067,-0l1.159,216.19l37.906,-0.084Z"
				style="stroke:{strokeColor};fill:{strokeColor};stroke-width:1px;"
			/><path
				id="U"
				d="M1354.81,256.785l-0,-35.52c-0,0 128.862,2.346 194.715,0c22.303,-0.794 105.271,0 105.271,-62.5c-0,-61.08 -76.159,-60.32 -105.271,-61.047c-65.403,-1.632 -194.715,0 -194.715,0l-0,-35.828c-0,-0 66.949,-0.296 194.715,0.011c21.729,0.052 143.974,-0.011 143.567,96.87c-0.412,98.013 -118.515,97.629 -143.567,98.064c-79.351,1.375 -194.715,-0.05 -194.715,-0.05Z"
				style="stroke:{strokeColor};fill:{strokeColor};stroke-width:1px;"
			/></g
		><g id="I"></g><path
			id="I--1-1"
			d="M2749.42,232.5c-5.991,-1.904 -12.165,-4.983 -18.412,-9.667c-16.799,-12.596 -34.438,-34.68 -53.746,-53.965c-49.738,-49.68 -100.622,-107.106 -100.622,-107.106l53.095,-0c0,-0 30.403,32.063 66.483,69.572c18.422,19.153 39.041,40.032 53.818,54.968c6.965,7.04 15.547,7.892 21.13,7.892c10.351,-0 20.507,-12.199 29.663,-21.405c17.516,-17.614 36.583,-38.306 49.711,-51.463c36.054,-36.132 57.199,-59.564 57.199,-59.564l52.498,-0c0,-0 -45.514,49.705 -91.633,97.767c-21.931,22.854 -43.816,50.632 -64.319,65.212c-5.833,4.148 -11.386,6.598 -16.931,8.069l0,205.428l-37.934,0l0,-205.738Z"
			style="stroke:{strokeColor};fill:{strokeColor};stroke-width:1px;"
		/><g id="X"
			><path
				d="M899.618,438.238c-0,0 40.373,-41.545 81.976,-85.198c14.906,-15.64 30.38,-32.091 44.689,-46.621c10.817,-10.986 19.878,-21.038 30.145,-27.883c11.882,-7.92 24.672,-10.047 34.988,-10.047c10.222,-0 23.709,1.356 36.054,9.735c8.337,5.66 17.157,15.189 25.693,23.802c15.087,15.222 30.1,31.639 45.794,47.727c44.506,45.627 84.257,88.485 84.257,88.485l-55.481,0c0,0 -34.386,-36.226 -65.73,-69.438c-10.255,-10.867 -21.613,-21.919 -30.029,-30.743c-15.287,-16.026 -26.312,-28.872 -40.558,-29.216c-10.593,-0.256 -19.758,8.1 -31.708,20.368c-9.597,9.85 -21.667,22.357 -32.6,33.93c-34.897,36.938 -71.413,75.099 -71.413,75.099l-56.077,0Z"
				style="fill:#faae1b;stroke:#faae1b;stroke-width:1px;"
			/><path
				id="Y"
				d="M899.618,61.762l53.095,-0c-0,-0 30.403,32.063 66.482,69.572c18.422,19.153 39.041,40.032 53.818,54.968c6.965,7.04 15.547,7.892 21.131,7.892c10.35,-0 20.506,-12.199 29.662,-21.405c17.516,-17.614 36.583,-38.306 49.712,-51.463c36.053,-36.132 57.198,-59.564 57.198,-59.564l52.498,-0c0,-0 -45.513,49.705 -91.633,97.767c-21.93,22.854 -43.816,50.632 -64.319,65.212c-12.34,8.775 -23.424,9.952 -35.846,10.34c-11.471,0.358 -24.286,-2.393 -37.431,-12.248c-16.799,-12.596 -34.438,-34.68 -53.745,-53.965c-49.738,-49.68 -100.622,-107.106 -100.622,-107.106Z"
				style="fill:#faae1b;stroke:#faae1b;stroke-width:1px;"
			/></g
		><path
			id="U1"
			d="M470.203,61.762l37.626,-0c0,-0 -1.199,136.523 1.306,198.395c0.848,20.955 10.895,71.485 61.704,111.185c32.964,25.756 71.277,29.354 87.492,29.586c17.151,0.245 62.041,-6.875 96.371,-34.553c30.773,-24.81 52.747,-72.94 53.523,-100.292c1.744,-61.45 -1.183,-204.321 -1.183,-204.321l38.223,-0c-0,-0 2.652,84.447 2.324,204.49c-0.056,20.414 -8.729,53.214 -25.51,81.612c-5.485,9.282 -29.332,44.354 -63.74,64.662c-34.275,20.229 -79.084,25.712 -98.216,25.712c-19.087,0 -49.843,-2.473 -75.317,-13.963c-33.095,-14.928 -59.799,-40.454 -66.368,-48.02c-9.251,-10.653 -17.316,-23.555 -24.39,-35.395c-16.465,-27.554 -21.737,-58.904 -22.2,-82.44c-1.469,-74.555 -1.645,-196.658 -1.645,-196.658Z"
			style="stroke:{strokeColor};fill:{strokeColor};stroke-width:1px;"
		/><path
			id="L1"
			d="M39.767,61.762l38.556,-0l0.348,337.354l336.644,0.156l0.152,38.927l-375.352,0.039l-0.348,-376.476Z"
			style="stroke:{strokeColor};fill:{strokeColor};stroke-width:1px;"
		/></g
	></svg
>

<style>
</style>
